import type { GrantFixedLevel, PermissionSetPermission, RecordPermission } from '@omnea-digital/authz-model'

/** Each Omnea-defined set's name under `settings.permission-sets`. */
export const FIXED_LEVEL_LABEL_KEYS = {
  viewer: 'fixed-level-name.viewer',
  owner: 'fixed-level-name.owner',
} as const satisfies Record<GrantFixedLevel, string>

/**
 * Each permission's name under `settings.permission-sets`, so every surface naming a permission
 * reads the same words. Covers both what a set configures and the wider set the model answers per
 * record, keyed exhaustively so either gaining a permission fails to compile until it has a name.
 */
export const PERMISSION_LABEL_KEYS = {
  view: 'permissions.view',
  assign: 'permissions.assign',
  create: 'permissions.create',
  create_product: 'permissions.createProduct',
  edit_po_number: 'permissions.editPoNumber',
  manage_followers: 'permissions.manageFollowers',
  edit_metadata: 'permissions.editMetadata',
  edit_submissions: 'permissions.editSubmissions',
  manage_assignees: 'permissions.manageAssignees',
  manage_participants: 'permissions.manageParticipants',
  manage_sourcing: 'permissions.manageSourcing',
  skip: 'permissions.skip',
  rollback: 'permissions.rollback',
  manage_integrations: 'permissions.manageIntegrations',
  pause: 'permissions.pause',
  reject: 'permissions.reject',
  view_tprm: 'permissions.viewTprm',
  manage_tprm: 'permissions.manageTprm',
  view_related_requests: 'permissions.viewRelatedRequests',
  view_related_agreements: 'permissions.viewRelatedAgreements',
  view_related_documents: 'permissions.viewRelatedDocuments',
  view_related_submissions: 'permissions.viewRelatedSubmissions',
  edit: 'permissions.edit',
  edit_documents: 'permissions.editDocuments',
  manage: 'permissions.manage',
  manage_documents: 'permissions.manageDocuments',
  manage_internal_contacts: 'permissions.manageInternalContacts',
  manage_external_contacts: 'permissions.manageExternalContacts',
  manage_products: 'permissions.manageProducts',
  add_agreement: 'permissions.addAgreement',
  administer: 'permissions.administer',
  cancel: 'permissions.cancel',
  delete: 'permissions.delete',
  manage_renewals: 'permissions.manageRenewals',
  view_documents: 'permissions.viewDocuments',
  view_related_supplier: 'permissions.viewRelatedSupplier',
  edit_before_accept: 'permissions.editBeforeAccept',
  accept: 'permissions.accept',
  approve: 'permissions.approve',
  create_request: 'permissions.createRequest',
} as const satisfies Record<PermissionSetPermission | RecordPermission, string>
